import Marquee from "react-fast-marquee";
import { Reveal, Overline } from "@/components/Motion";

// Company names extracted from the client-provided collaborations wall.
const COMPANIES = [
  "Cenomi", "DXB Live", "Tahaluf", "GWM", "STid", "Swarco", "INPEX", "Toyota",
  "Panasonic", "Chiyoda", "NAFFCO", "Teletek", "Sensormatic", "TMG", "KADEN",
  "Saudi Bonyan", "Regal London", "Diriyah", "DAMEN", "Eni", "NMDC Group",
  "Lamborghini", "GEWISS", "Jameel Motors", "Invest Saudi", "Yardi", "Newlab",
  "Junta de Castilla y León",
];
const ROW_A = COMPANIES.slice(0, 14);
const ROW_B = COMPANIES.slice(14);

const STATS = [
  ["45+", "Organisations served"],
  ["Global", "Regional & international"],
  ["Multi-sector", "Energy · Tech · Real estate & more"],
];

const NameItem = ({ name }) => (
  <span className="flex items-center whitespace-nowrap">
    <span className="mx-10 md:mx-16 font-serif font-light text-3xl md:text-5xl tracking-wide text-evo-pearl/80">
      {name}
    </span>
    <span className="text-evo-gold/50 text-lg md:text-xl" aria-hidden="true">✦</span>
  </span>
);

export const TrustedExperience = () => (
  <section data-testid="trusted-experience" className="relative overflow-hidden border-y border-white/8 py-24 md:py-32">
    <div className="px-6 md:px-12 lg:px-20 mb-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7">
          <Reveal><Overline className="block mb-6">Trusted Experience</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-evo-pearl text-balance">
              Trusted by global organisations, <span className="text-evo-gold italic">across the region and beyond</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 text-evo-ash font-light max-w-xl leading-relaxed">
              A track record built on trust, craft and consistent delivery — for brands, institutions and national pavilions worldwide.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-5 flex flex-wrap content-center gap-x-12 gap-y-8">
          {STATS.map(([big, small]) => (
            <Reveal key={small}>
              <p className="font-serif text-3xl md:text-4xl text-evo-gold">{big}</p>
              <p className="text-[11px] uppercase tracking-[0.2em] text-evo-ash mt-2">{small}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>

    <div className="space-y-6 md:space-y-8">
      <Marquee speed={22} gradient={false} autoFill pauseOnHover>
        {ROW_A.map((n) => <NameItem key={n} name={n} />)}
      </Marquee>
      <Marquee speed={22} direction="right" gradient={false} autoFill pauseOnHover>
        {ROW_B.map((n) => <NameItem key={n} name={n} />)}
      </Marquee>
    </div>
  </section>
);
